import { isCryptoCurrency } from '@/utils/currencies';

export { isCryptoCurrency };

/**
 * Format a monetary amount for display.
 * Fiat → 2 decimal places; crypto → up to 8 decimals with trailing zeros trimmed.
 *
 * @param {string|number|null|undefined} value
 * @param {string|null|undefined} currency
 * @returns {string|null} Formatted string, or null when value is empty/invalid
 */
export function formatAmount(value, currency) {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const numeric = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(numeric)) {
    return null;
  }

  if (isCryptoCurrency(currency)) {
    const fixed = numeric.toFixed(8);
    return fixed.replace(/\.?0+$/, '') || '0';
  }

  return numeric.toFixed(2);
}
